import React, { PureComponent } from 'react'

// local components
import MemberGroupItem from './MemberGroupItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

const MemberGroupItemEditable = EditableHOCWrapper(MemberGroupItem)

class MemberGroupItemContainer extends PureComponent {
  onSave = (data, afterOnSave) => {
    this.props.onMemberGroupUpdate(data, afterOnSave)
  }

  render() {
    const {
      memberGroup = {},
      lastModified = null,
      defaultEditMode = false,
      onCancel,
      onDelete,
    } = this.props

    return (
      <MemberGroupItemEditable
        dataToEdit={memberGroup}
        onSave={this.onSave}
        lastModified={lastModified}
        defaultEditMode={defaultEditMode}
        onCancel={onCancel}
        onDelete={onDelete}
      />
    )
  }
}

export default MemberGroupItemContainer



// WEBPACK FOOTER //
// ./src/components/MemberGroups/MembershipItemContainer.js